import React from 'react';
import { Typography, Box } from '@mui/material';
import PolicyHeader from './PolicyHeader';
import CommonMapFunction from './CommonMapFunction';
import { companyDetails } from 'utils/companyDetails';
import { getBranding } from 'config/tenantConfig';
import Policy from './Policy';
import companyLogo from 'assets/images/companyLogo.svg';
import {
  termDataOne,
  termDataTwo,
  termDataThree,
  termDataFour,
  termDataFive,
  termDataSix,
  termDataSeven,
  termDataEight,
  termDataNine,
} from './TermAndConditionData';

function TermAndCondition() {
  const searchParams = new URLSearchParams(window.location.search);
  const isMobileParams = searchParams.get('isMobile') === 'true';
  return (
    <div>
      {!isMobileParams && <PolicyHeader />}
      <div>
        {!isMobileParams && (
          <Typography className="justifyCenter fw500 headerText pt20 pb30">
            {companyDetails?.companyName} - Terms and Conditions – Users
          </Typography>
        )}

        {/* Header section with logo and title - appears only once */}
        <div className="customerPolicyLayout mt-10">
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <img 
              src={getBranding().logo || companyLogo} 
              alt="Company Logo" 
              style={{ height: "100px", width: "120px", marginLeft: "-16px" }}
            />
            <Typography variant="h5" sx={{ color: "var(--brand-primary)", fontWeight: 450 }}>
              Your Agreement with <span style={{ fontWeight: 600 }}>ITER Mobility</span>
            </Typography>
          </Box>
          <Typography sx={{ fontSize: "14px", color: "#666666", marginBottom: "24px" }}>
            Last updated: 21/01/2026
          </Typography>
          <Box sx={{ borderBottom: "2px dashed #cccccc", marginBottom: "32px" }} />
        </div>

        <CommonMapFunction data={termDataOne} />
        <Policy policyData={termDataTwo} />
        <CommonMapFunction data={termDataThree} />
        <Policy className="policyTitle" policyData={termDataFour} subsection="term" />
        <CommonMapFunction data={termDataFive} />
        <Policy className="policyTitle" policyData={termDataSix} />
        <CommonMapFunction data={termDataSeven} />

        <div className="customerPolicyLayout">
          <p className="policyTitle">
            23. Updates to Terms & Conditions
          </p>
          <p variant="body2" className="policyDescription">
            {companyDetails?.companyName} reserves the right to update these Terms at any time.
            We will notify you of any changes by posting the revised Terms on
            the App and our website &nbsp;
            <span>
              <a href="https://iter.co.in/" target="_blank">
                https://iter.co.in/
              </a>
            </span>
          </p>
        </div>
        <Policy policyData={termDataEight} />
        <CommonMapFunction data={termDataNine} />
      </div>
    </div>
  );
}

export default TermAndCondition;
